import { makeStyles } from '@mui/styles'
import {
  ERROR,
  GAINSBORO_BORDER,
  GRAYISH_BLUE,
  NEON_BLUE_LIGHT,
  SHAMROCK,
  SILVER_SAND,
  SLATE_GREY,
  SONIC_SILVER,
} from '@returnmates/client-core/src/constants/colors'
import { URBANIST } from '@returnmates/ui-core/src/constants/styles/fonts'

interface Props {
  isTriplessEnabledHub?: boolean
}

const useStyles = makeStyles(() => ({
  iconCell: {
    display: 'flex',
    alignItems: 'center',
  },
  linkFormatterHyperlink: {
    color: NEON_BLUE_LIGHT,
    textDecoration: 'underline',
  },
  linkFormatterWrapper: {},
  carrierCell: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  toolbar: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '15px',
  },
  toolbarLeftPart: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '80%',
  },
  toolbarRightPart: {
    minWidth: 'max-content',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '20%',
  },
  receivedCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: GRAYISH_BLUE,
  },
  receivedIcon: {
    marginRight: 0,
    color: NEON_BLUE_LIGHT,
  },
  disabledIcon: {
    cursor: 'not-allowed',
    pointerEvents: 'all',
    color: 'rgba(167, 180, 200, .4)',
    opacity: 0.6,
  },
  filterPanel: {
    position: 'absolute',
    top: -48,
    right: ({ isTriplessEnabledHub }: Props) => (isTriplessEnabledHub ? 200 : 0),
    width: 'max-content',
  },
  noUrl: {
    color: ERROR,
  },
  undersCheckbox: {
    display: 'flex',
    alignItems: 'center',

    '& span': {
      fontSize: 14,
      fontWeight: 700,
      color: SONIC_SILVER,
      lineHeight: '19.6px',
      fontFamily: URBANIST,
    },
  },
  linkIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  printLabelsContainer: {
    position: 'relative',
  },
  moreFiltersContainer: {
    position: 'relative',
    marginLeft: '10px',
  },
  exportToCSVContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 14px',
    cursor: 'pointer',
  },
  exportToCSV: {
    fontSize: 14,
    fontWeight: 700,
    color: SONIC_SILVER,
    lineHeight: '19.6px',
    marginLeft: 10,
    fontFamily: URBANIST,
  },
  printLabelsButton: {
    background: SHAMROCK,
    borderRadius: 4,
    width: 145,
    height: 38,
    fontSize: 14,
  },
  moreFiltersButton: {},
  '@keyframes fadeInDown': {
    '0%': {
      opacity: 0,
      transform: 'translateY(-10px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  popupContainer: {
    width: 200,
    position: 'absolute',
    top: 45,
    zIndex: 999,
    background: '#FFFEFE',
    border: `1px solid ${SILVER_SAND}`,
    borderRadius: 3,
    padding: '10px 5px 5px 5px',
    animation: `$fadeInDown 0.3s ease-out`,
    boxShadow: '3px 4px 4px 0px #00000040',
  },
  moreFiltersPopupContainer: {
    width: 210,
    position: 'absolute',
    top: 45,
    right: 0,
    zIndex: 999,
    background: '#FFFEFE',
    border: `1px solid ${SILVER_SAND}`,
    borderRadius: 3,
    padding: 5,
    animation: `$fadeInDown 0.3s ease-out`,
    boxShadow: '4px 4px 4px 0px #00000040',
  },
  moreIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: 3,
    padding: '7px 8px',

    '&:hover': {
      background: GAINSBORO_BORDER,
    },
  },
  counterWrap: {
    maxHeight: 30,
    width: 160,
    margin: '10px 15px 0',
  },
  counterButton: {
    borderRadius: 0,
    maxHeight: 'inherit',
    padding: '0 20px',
  },
  counterInput: {
    '& > div': {
      borderRadius: 0,
    },
    '& input': {
      textAlign: 'center',
    },
  },
  closeIconContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    '& > svg': {
      height: 16,
      cursor: 'pointer',
    },
  },
  radioItemContainer: {
    display: 'flex',
    alignItems: 'center',
    '& > span': {
      padding: 7,
    },
  },
  radioGroupContainer: {},
  printButton: {
    background: SHAMROCK,
    borderRadius: 4,
    marginBottom: '10px',
    height: '20px',
    marginTop: 15,
    fontSize: 14,
    fontFamily: URBANIST,
  },
  printOption: {
    fontSize: 14,
    fontFamily: URBANIST,
    color: SONIC_SILVER,
  },
  printOptionDisabled: {
    color: SLATE_GREY,
  },
  clearFilters: {
    fontSize: 14,
    fontFamily: URBANIST,
    fontWeight: 700,
    background: 'transparent',
    color: SONIC_SILVER,
    height: 40,

    '&:hover': {
      background: 'transparent',
    },
  },
  plusIcon: {
    '& path': {
      stroke: '#FFFFFF',
    },
  },
  addPackageButton: {
    padding: '8.5px 23px',
    marginRight: 10,
  },
}))

export default useStyles
